export default "__VITE_ASSET__ff6ac353__"